import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, FormControlLabel, InputAdornment, Switch, TextField } from '@mui/material';
import PropTypes from 'prop-types';

const PartnerPreferenceToolbar = ({
  search,
  onSearchChange,
  showInactivePartners,
  onShowInactivePartnersChange,
  canManage,
  onAdd,
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      flexWrap: 'wrap',
      mb: 1.5,
    }}
  >
    <TextField
      size='small'
      value={search}
      onChange={(event) => onSearchChange(event.target.value)}
      placeholder='Search partner'
      InputProps={{
        inputProps: { 'aria-label': 'Search partner' },
        startAdornment: (
          <InputAdornment position='start'>
            <SearchIcon fontSize='small' />
          </InputAdornment>
        ),
      }}
      sx={{ minWidth: 260 }}
    />

    <Box sx={{ flexGrow: 1 }} />

    {/* Partner status, not preference status — a disabled or suspended partner is
        not worth reading past by default, but its preferences still exist and are
        one switch away. */}
    <FormControlLabel
      control={
        <Switch
          size='small'
          checked={showInactivePartners}
          onChange={(event) => onShowInactivePartnersChange(event.target.checked)}
        />
      }
      label='Include inactive partners'
      sx={{ mr: 0.5, '& .MuiFormControlLabel-label': { fontSize: 13 } }}
    />

    {canManage && (
      <Button variant='contained' size='small' onClick={onAdd}>
        + New Partner Preference
      </Button>
    )}
  </Box>
);

PartnerPreferenceToolbar.propTypes = {
  search: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  showInactivePartners: PropTypes.bool.isRequired,
  onShowInactivePartnersChange: PropTypes.func.isRequired,
  canManage: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default PartnerPreferenceToolbar;
